import React, { useEffect, useState } from "react";
import { CloseButton, Modal } from "react-bootstrap";
import {
  Button
} from "antd";


function SegmentViewAll({ modalShow, setModalShow, condition }) {
  const [conditions, setCondtions] = useState([]);

  const isTypeDate = (condition) => {
    if (
      condition === "order delivered date" ||
      condition === "order created" ||
      condition === "engagement reminder date" ||
      condition === "slot booking"
    ) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    if (condition?.length) {
      let implimetedText = condition?.map((item, index) => {
        if (condition.length - 1 === index) {
          if (isTypeDate(item?.condition)) {
            return {
              text: `${index + 1}. ${item?.condition} ${
                item?.conditionType || item?.condtionType
              } ${
                item?.value === undefined
                  ? `${DateReverse(item?.fromValue)} to ${DateReverse(
                      item?.toValue
                    )}`
                  : `${DateReverse(item?.value)}`
              } `,
              condition: item.isAnd === true ? "" : "",
            };
          } else {
            return {
              text: `${index + 1}. ${item?.condition} ${
                item?.conditionType || item?.condtionType
              } ${
                item?.value === undefined
                  ? `${item?.fromValue} to ${item?.toValue}`
                  : `${item?.value}`
              } `,
              condition: item.isAnd === true ? "" : "",
            };
          }
        }
        if (isTypeDate(item?.condition)) {
          return {
            text: `${index + 1}. ${item?.condition} ${
              item?.conditionType || item?.condtionType
            } ${
              item?.value === undefined
                ? `${DateReverse(item?.fromValue)} to ${DateReverse(
                    item?.toValue
                  )}`
                : `${DateReverse(item?.value)}`
            } `,
            condition: condition[index + 1].isAnd === true ? "(AND)" : "(OR)",
          };
        } else {
          return {
            text: `${index + 1}. ${item?.condition} ${
              item?.conditionType || item?.condtionType
            } ${
              item?.value === undefined
                ? `${item?.fromValue} to ${item?.toValue}`
                : `${item?.value}`
            } `,
            condition: condition[index + 1].isAnd === true ? "(AND)" : "(OR)",
          };
        }
      });
      if (implimetedText.length === 0) {
        implimetedText = condition.map((item, index) => {
          return {
            text: `${index + 1}. User Type = ${item?.user_type} `,
            condition: item.isAnd === true ? "" : "",
          };
        });
      }
      setCondtions(implimetedText);
    } else {
      setCondtions([]);
    }
  }, [condition]);

  return (
    <div>
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            Conditions
          </Modal.Title>
          <CloseButton
            className="btn btn-circle btn-sm transition-base p-0"
            onClick={() => setModalShow(false)}
          />
        </Modal.Header>
        <Modal.Body
          className="scrollable-container"
          style={{ maxHeight: "82vh", overflowY: "scroll" }}
        >
          {conditions?.map((item, index) => (
            <div key={index} style={{ marginBottom: "10px" }}>
              <div className="fw-bold">
                {`${item?.text}`}
                <span>{item?.condition}</span>
              </div>
            </div>
          ))}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setModalShow(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default SegmentViewAll;
